import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PADSPLASHSCREENBLOCK_LEGACY_FIELD_ORDER = [];

const {
  padSplashScreenBlockDescriptor: _generatedPadSplashScreenBlockDescriptor,
  padSplashScreenBlockBlocDefinition,
  padSplashScreenBlockDashboardLayout,
  padSplashScreenBlockConfig,
  padSplashScreenBlockResolveConfig,
  padSplashScreenBlockProperties,
} = doodBlockConfig(
  {
    name: "Pad - Splash screen",
    componentType: 'PadSplashScreenBlockComponent',
    category: 'system',
    description: "Pad - Splash screen.",
    keywords: [],
    allowedIn: [
      { bloc: 'MainLayoutComponent', slot: '*' },
    ],

    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function padSplashScreenBlockDescriptor(): IBlockDescriptor;
export function padSplashScreenBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function padSplashScreenBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPadSplashScreenBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPadSplashScreenBlockDescriptor, padSplashScreenBlockProperties, fieldOrder);
}

export {
  padSplashScreenBlockBlocDefinition,
  padSplashScreenBlockDashboardLayout,
  padSplashScreenBlockProperties,
  padSplashScreenBlockConfig,
  padSplashScreenBlockResolveConfig,
};

export type PadSplashScreenBlockConfig = typeof padSplashScreenBlockConfig;
